import createLucideIcon from '../createLucideIcon';

const Share = createLucideIcon('ShareIcon', [
  ['path', { d: 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8', key: '1b2hhj' }],
  ['polyline', { points: '16 6 12 2 8 6', key: 'm901s6' }],
  ['line', { x1: '12', y1: '2', x2: '12', y2: '15', key: '1sxkij' }],
]);

export default Share;
